import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { getAssetURL } from 'lib/utility/GetAssetUrl'
import variables from 'assets/styles/scss/shared/_variables.module.scss'

const StyledNoData = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CardEmpty = () => {
  const { t } = useTranslation()
  return (
    <StyledNoData>
      <Box component="img" src={getAssetURL('/empty/noData.svg')} alt="" />
      <Typography variant="body2" color={variables['black']}>
        {t('common.noDataToDisplay')}
      </Typography>
    </StyledNoData>
  )
}

export { CardEmpty }
